import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { QuestionDescriptionFields, ScaleSelect } from './EvaluationScaleShared';
import { STAR_N_OPTIONS, makeSimpleChoices } from '../EvaluationScaleConfig';

export const StarScaleLayout = ({ valuePath, questionChoicesAttributes = [] }) => {
  const { setFieldValue } = useFormikContext();
  const visibleChoices = questionChoicesAttributes.filter(c => !c._destroy);
  const n = visibleChoices.length || 5;

  const handleNChange = val => {
    setFieldValue(`${valuePath}[questionChoicesAttributes]`, makeSimpleChoices(parseInt(val, 10)));
  };

  return (
    <div className="mt-3">
      <QuestionDescriptionFields
        valuePath={valuePath}
        descriptionPlaceholder="Selecciona la cantidad de estrellas"
      />
      <ScaleSelect
        label="N° de Estrellas"
        options={STAR_N_OPTIONS}
        value={n}
        onChange={handleNChange}
      />
      <Row>
        <Col>
          <p className="text-muted mb-1">
            Respuesta: <span className="eval-scale-preview-hint">(Vista Previa)</span>
          </p>
          <div className="eval-star-row">
            {Array.from({ length: n }, (_, i) => (
              <span key={i} className="eval-star-icon">☆</span>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StarScaleLayout;
